import { Tooltip } from "@material-tailwind/react";

const PremiumIcon = () => {
  return (
    <Tooltip content="Premium Article">
      <span>👑&nbsp;</span>
    </Tooltip>
  );
};

export default PremiumIcon;
